// Vendor imports
const Immutable = require('immutable')
const { createSelector } = require('reselect')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const IntoFeedItem = require('./components/feed-item')

function onContentCardClick() {
  businessEvents.trackSegment('into-content-card-click')
}

function renderIntoItemCard({ id, item }) {
  return (
    tag(IntoFeedItem, {
      key: id,
      href: item ? `!${item.article['url_hash']}` : null,
      item,
      onClick: onContentCardClick
    })
  )
}

function createIntoItemCardFeedItem(item, index) {
  return {
    id: `into-item-card:${index}`,
    item,
    type: 'render',
    render: renderIntoItemCard
  }
}

const getItemCards = createSelector(
  items => items,
  items => {
    let emptyItemsCount = 0
    if (items.size < 12) {
      emptyItemsCount = 12 - items.size
    }
    return Immutable.List(
      [...items, ...new Array(emptyItemsCount)].map((item, index) => createIntoItemCardFeedItem(item, index))
    )
  }
)

module.exports = {
  getItemCards
}
